import messages from '../../../../../messages/table';

function TableSchema(props) {
  const { intl, data } = props;

  return {
    title: intl.formatMessage(messages.titleBlock),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'caption',
          'showCaption',
          'hideHeaders',
          'sortable',
          'fixed',
          'striped',
          'compact',
        ],
      },
    ],
    properties: {
      hideHeaders: {
        title: intl.formatMessage(messages.hideHeaders),
        type: 'boolean',
        isDisabled: data?.table?.sortable,
      },
      sortable: {
        title: intl.formatMessage(messages.sortable),
        type: 'boolean',
        isDisabled: data?.table?.hideHeaders,
      },
      fixed: {
        title: intl.formatMessage(messages.fixed),
        type: 'boolean',
      },
      striped: {
        title: intl.formatMessage(messages.striped),
        type: 'boolean',
      },
      compact: {
        title: intl.formatMessage(messages.compact),
        type: 'boolean',
      },
      caption: {
        title: intl.formatMessage(messages.tableTitle),
        description: intl.formatMessage(messages.tableTitleDescription),
      },
      showCaption: {
        title: intl.formatMessage(messages.showTitle),
        type: 'boolean',
      },
    },
    required: ['caption'],
  };
}

export function TableBlockSchema(props) {
  const { intl } = props;
  return {
    title: intl.formatMessage(messages.titleBlock),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['table'],
      },
    ],
    properties: {
      table: {
        title: intl.formatMessage(messages.titleBlock),
        widget: 'object',
        schema: TableSchema(props),
      },
    },

    required: [],
  };
}

export default TableBlockSchema;
